import React from 'react';
import { FooterStoryblok } from '../../../_shared/interfaces/storyblok';
import { getLinkFragment } from '../../../lib/link-fragment/link-fragment';
import { StoryblokCommon } from '../../../lib/storyblok/storyblok';

import * as FooterStylesHs from './footer.hs.module.scss';
import * as FooterStylesDr from './footer.dr.module.scss';

const Footer = ({
    showCookieLayer,
    blok,
    storyblokCommon,
}: {
    showCookieLayer: () => any;
    blok: FooterStoryblok;
    storyblokCommon: StoryblokCommon;
}) => {
    const FooterStyles = storyblokCommon.configuration.content.theme === 'dr' ? FooterStylesDr : FooterStylesHs;
    const scrollToTop = () => {
        if (typeof window !== 'undefined') {
            const c = document.documentElement.scrollTop || document.body.scrollTop;
            if (c > 0) {
                window.scroll({
                    behavior: 'smooth',
                    left: 0,
                    top: 0,
                });
            }
        }
    };

    const toggleCookieLayer = (e: any) => {
        e.preventDefault();
        showCookieLayer();
    };

    return (
        <footer>
            <div className={FooterStyles.desktop}>
                <button className={FooterStyles.button} onClick={scrollToTop} aria-label={blok.scroll_top_aria_label} />

                <div className={FooterStyles.inner}>
                    <nav className={FooterStyles.nav} role="menu">
                        {blok.links.map((navEntry) => {
                            return (
                                <div key={navEntry._uid} role="none">
                                    {navEntry.privacy_settings ? (
                                        <a href="#" onClick={toggleCookieLayer} role="menuitem">
                                            {navEntry.text}
                                        </a>
                                    ) : (
                                        getLinkFragment(navEntry, FooterStyles.linkActive)
                                    )}
                                </div>
                            );
                        })}
                    </nav>

                    <div className={FooterStyles.copyright}>
                        <p>
                            <small>{blok.copyright}</small>
                        </p>
                    </div>
                </div>
            </div>

            <div className={FooterStyles.mobile}>
                <p>
                    <small>{blok.copyright}</small>
                </p>

                <button className={FooterStyles.button} onClick={scrollToTop} aria-label={blok.scroll_top_aria_label} />
            </div>
        </footer>
    );
};

export default Footer;
